export function template(str) {
  let code = 'let __o = "";';
  for (const part of str.split(/(\{\{[\s\S]*?\}\})/g)) {
    if (part.startsWith('{{=')) {
      code += `__o += (${part.slice(3, -2)});`;
    } else if (part.startsWith('{{')) {
      code += part.slice(2, -2);
    } else if (part) {
      code += `__o += ${JSON.stringify(part)};`;
    }
  }
  return new Function('it', code + 'return __o;');
}
